import propertyOptionItems from 'client/helpers/propertyOptionItems';
import bedroomRangeOptionItems from 'client/helpers/bedroomRangeOptionItems';
import bedroomRangeMultiOptionItems from 'client/helpers/bedroomRangeMultiOptionItems';
import leaseTermOptionItems from 'client/helpers/leaseTermOptionItems';
import petCountOptionItems from 'client/helpers/petCountOptionItems';
import petTypeOptionItems from 'client/helpers/petTypeOptionItems';
import startTouringOptionItems from 'client/helpers/startTouringOptionItems';
import laundryOptionItems from 'client/helpers/laundryOptionItems';
import roommateCountOptionItems from 'client/helpers/roommateCountOptionItems';
import creditScoreOptionItems from 'client/helpers/creditScoreOptionItems';
import propertyPricesOptionItems from 'client/helpers/propertyPricesOptionItems';

import leaseSituationOptionItems, {
  RENTER_LEASE_SITUATION_OPTION_FIRM,
} from 'common/leaseSituationOptionItems';

import {
  SCREEN_ID_ONBOARDING_PROPERTY_TYPES,
  SCREEN_ID_ONBOARDING_BEDROOMS,
  SCREEN_ID_ONBOARDING_BEDROOMS_MULTI,
  SCREEN_ID_ONBOARDING_PROPERTY_PRICES,
  SCREEN_ID_ONBOARDING_PROPERTY_PRICES_RANGE,
  SCREEN_ID_ONBOARDING_LEASE_SITUATION,
  SCREEN_ID_ONBOARDING_LEASE_TERM,
  SCREEN_ID_ONBOARDING_MOVE_IN_DATE,
  SCREEN_ID_ONBOARDING_PET_COUNT,
  SCREEN_ID_ONBOARDING_PETS,
  SCREEN_ID_ONBOARDING_MARKET,
  SCREEN_ID_ONBOARDING_LOCATION,
  SCREEN_ID_ONBOARDING_START_TOURING,
  SCREEN_ID_ONBOARDING_NAME,
  SCREEN_ID_ONBOARDING_EMAIL,
  SCREEN_ID_ONBOARDING_PASSWORD,
  SCREEN_ID_ONBOARDING_PHONE,
  SCREEN_ID_ONBOARDING_LAUNDRY,
  SCREEN_ID_ONBOARDING_ROOMMATE_COUNT,
  SCREEN_ID_ONBOARDING_CREDIT_SCORE,
} from 'client/constants/screenIds';

export default {
  propertyTypes: {
    id:'propertyTypes',
    type: 'checkbox-list',
    title:'What type of place do you want to rent?',
    multi: true,
    optionList: propertyOptionItems,
    screenId: SCREEN_ID_ONBOARDING_PROPERTY_TYPES,
  },
  bedrooms: {
    id: 'bedrooms',
    type: 'checkbox-list',
    title: 'Number of bedrooms needed?',
    multi: false,
    optionList: bedroomRangeOptionItems,
    screenId: SCREEN_ID_ONBOARDING_BEDROOMS,
  },
  bedroomsMulti: {
    id: 'bedroomsMulti',
    type: 'checkbox-list',
    title: 'Number of bedrooms needed?',
    multi: true,
    optionList: bedroomRangeMultiOptionItems,
    screenId: SCREEN_ID_ONBOARDING_BEDROOMS_MULTI,
  },
  propertyPrices: {
    id: 'propertyPrices',
    type: 'checkbox-list',
    title: 'How much do you want to pay for rent each month?',
    multi: true,
    optionList: propertyPricesOptionItems,
    screenId: SCREEN_ID_ONBOARDING_PROPERTY_PRICES,
  },
  propertyPricesRange: {
    id: 'propertyPricesRange',
    type: 'currency-range',
    title: 'How much do you want to pay for rent each month?',
    explainerText: 'Not including utilities or other monthly fees.',
    screenId: SCREEN_ID_ONBOARDING_PROPERTY_PRICES_RANGE,
  },
  leaseSituation: {
    id: 'leaseSituation',
    type: 'checkbox-list',
    title: 'What\'s your current lease situation?',
    multi: false,
    optionList: leaseSituationOptionItems,
    screenId: SCREEN_ID_ONBOARDING_LEASE_SITUATION,
  },
  moveInDate: {
    id: 'moveInDate',
    type: 'datetime',
    title: (onboardingValues) => onboardingValues.leaseSituation === RENTER_LEASE_SITUATION_OPTION_FIRM
      ? 'When does your lease end?'
      : 'When would you like to move?',
    placeholder: 'Choose date...',
    screenId: SCREEN_ID_ONBOARDING_MOVE_IN_DATE,
  },
  moveDateRange: {
    id: 'moveDateRange',
    type: 'date-range',
    title: 'When would you like to move?',
    explainerText: 'The window of time you\'re ok to move and start paying rent on your new lease.',
    screenId: SCREEN_ID_ONBOARDING_MOVE_IN_DATE,
  },
  leaseTerm: {
    id: 'leaseTerm',
    type: 'checkbox-list',
    title: 'How many months are you planning to rent for?',
    multi: false,
    optionList: leaseTermOptionItems,
    screenId: SCREEN_ID_ONBOARDING_LEASE_TERM,
  },
  petCount: {
    id: 'petCount',
    type: 'checkbox-list',
    title: 'How many pets do you have?',
    multi: false,
    allowEmptyValue: false,
    optionList: petCountOptionItems,
    screenId: SCREEN_ID_ONBOARDING_PET_COUNT,
  },
  pets: {
    id: 'pets',
    type: 'checkbox-list',
    title: (onboardingValues) => onboardingValues.petCount === 1
      ? 'What type of pet?'
      : 'What type of pets?',
    allowEmptyValue: true,
    optionList: (onboardingValues) => petTypeOptionItems(onboardingValues.petCount),
    screenId: SCREEN_ID_ONBOARDING_PETS,
  },
  marketId: {
    id: 'marketId',
    type: 'checkbox-list',
    title: 'Where do you want to live?',
    multi: false,
    optionList: (onboardingValues, onboardingProps) => {
      return onboardingProps.marketList.map((market) => ({
        label: market.displayNameFull,
        value: market.id,
      }));
    },
    screenId: SCREEN_ID_ONBOARDING_MARKET,
  },
  area: {
    id:'area',
    type: 'map-draw',
    title:'Drag the dots on the map to choose where you want to live.',
    nextTitleButton: 'choose area',
    screenId: SCREEN_ID_ONBOARDING_LOCATION,
  },
  startTouring: {
    id: 'startTouring',
    type: 'checkbox-list',
    title: 'How soon do you want to go tour rentals with Sunroom?',
    multi: false,
    optionList: startTouringOptionItems,
    screenId: SCREEN_ID_ONBOARDING_START_TOURING,
  },
  name: {
    id: 'name',
    type: 'text',
    title: 'What\'s your name?',
    explainerText: 'We don\'t share your data.',
    placeholder: 'Write your name here...',
    screenId: SCREEN_ID_ONBOARDING_NAME,
  },
  email: {
    id: 'email',
    type: 'email',
    title: 'Email address?',
    placeholder: 'Write your email...',
    screenId: SCREEN_ID_ONBOARDING_EMAIL,
  },
  phoneNumber: {
    id: 'phoneNumber',
    type: 'tel',
    title: 'Phone number? (10 digits)',
    explainerText: 'Used for touring homes, we never spam.',
    placeholder: '5121234567',
    screenId: SCREEN_ID_ONBOARDING_PHONE,
  },
  password: {
    id: 'password',
    type: 'password',
    title: 'Create password',
    explainerText: 'Save your search and homes you like!',
    placeholder: 'Password',
    screenId: SCREEN_ID_ONBOARDING_PASSWORD,
  },
  laundryPreference: {
    id: 'laundryPreference',
    type: 'checkbox-list',
    title: 'What\'s your Washer/Dryer preference?',
    multi: true,
    optionList: laundryOptionItems,
    screenId: SCREEN_ID_ONBOARDING_LAUNDRY,
  },
  roommateCount: {
    id: 'roommateCount',
    type: 'checkbox-list',
    title: 'How many roommates are you moving with?',
    multi: false,
    optionList: roommateCountOptionItems,
    screenId: SCREEN_ID_ONBOARDING_ROOMMATE_COUNT,
  },
  creditScore: {
    id: 'creditScore',
    type: 'checkbox-list',
    title: 'What\'s your credit score?',
    multi: false,
    optionList: creditScoreOptionItems,
    screenId: SCREEN_ID_ONBOARDING_CREDIT_SCORE,
  },
};
